import { useMemo, useState } from 'react';
import { SortDescriptor } from '@heroui/react';
import type { CdnProviderItem } from '@/types';

export function useCdnProvidersSorting(cdnProviders: CdnProviderItem[]) {
  const [sortDescriptor, setSortDescriptor] = useState<SortDescriptor | undefined>(undefined);

  const sortedCdnProviders = useMemo(() => {
    if (!sortDescriptor?.column) return cdnProviders;

    return [...cdnProviders].sort((a, b) => {
      let first: string;
      let second: string;

      switch (sortDescriptor.column) {
        case 'name':
          first = a.name.toLowerCase();
          second = b.name.toLowerCase();
          break;
        case 'base_url':
          first = a.base_url.toLowerCase();
          second = b.base_url.toLowerCase();
          break;
        case 'is_default':
          first = a.is_default ? '1' : '0';
          second = b.is_default ? '1' : '0';
          break;
        default:
          first = a.name.toLowerCase();
          second = b.name.toLowerCase();
      }

      const cmp = first < second ? -1 : first > second ? 1 : 0;
      return sortDescriptor.direction === 'descending' ? -cmp : cmp;
    });
  }, [cdnProviders, sortDescriptor]);

  return {
    sortDescriptor,
    setSortDescriptor,
    sortedItems: sortedCdnProviders,
  };
}
